import React, { useState, useEffect } from 'react'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import { LogoType } from './logotype'
import Button from '@material-ui/core/Button'
import Divider from '@material-ui/core/Divider'
import useTheme from '@material-ui/core/styles/useTheme'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { useRest } from '../contexts/rest/use'
import { useTranslation } from '../contexts/i18n/use'
import { DropdownMenu } from './helpers/dropdownmenu'
import { useConfig } from '../contexts/config/use'
import { isFalsyOrEmpty } from './helpers/object'

export const Header = () => {
  const theme = useTheme();
  const classes = useStyles(theme)
  const { state: {config}} = useConfig();
  const { state: { selectedoffice, offices, ticket, selectedqueuename }, actions: { handleChangeOffice } } = useRest();
  const { actions: {t, qt }} = useTranslation();
  const [menuitems, setMenuItems] = useState();
  const [office, setOffice] = useState();
  const [officename, setOfficeName] = useState();

  useEffect(() => {
    if (offices && selectedoffice)
      setOffice(offices.find(x => x.officeID === selectedoffice))
  }, [offices, selectedoffice])

  useEffect(() => {
    if (!isFalsyOrEmpty(offices))
    {
      OfficeSelection();
      var office = offices.find(x => x.officeID === selectedoffice);
      if (office)
        setOfficeName(office.name);
      else 
        setOfficeName(t('header.noneselected'));
    }
  }, [offices])

  useEffect(() => {
    if (config)
    {
      setMenuItems(<DropdownMenu languages={config ? config.languages : null}/>);
    }
    else
      setMenuItems(<span/>);
  }, [config])

  const OfficeSelection = () => {
    if (config && office)
    {
      const queue = localStorage.getItem("selectedqueue");
      const queuename = localStorage.getItem("selectedqueuename");
      if (!isFalsyOrEmpty(ticket) || !config.uselandingpage || !isFalsyOrEmpty(queue) || !isFalsyOrEmpty(queuename))
      {
        return (
          <div className={classes.officeinfo}>
          <Typography>
            { office.address.street + " " + office.address.zipcode + " " + office.address.city }
          </Typography>
          <Typography variant="h5" className={classes.queuetext} id="header-queuename-text-id">
          { qt(queue) ? qt(queue) : (localStorage.getItem("selectedqueuename") || "")}
          </Typography>
          </div>
        )
      }
      else // Show "change office" button
      {
        return (
          <Button
          variant="contained"
          className={[classes.officebutton, "buttons"].join(' ')}
          id="header-button-id"
          size="small"
          elevation={0}
          onClick={() => handleChangeOffice()}
          disabled={!isFalsyOrEmpty(ticket) && !ticket.cancelled}
        >
          { 
            <Typography id="header-button-text-id">
              {t('header.changeoffice') || "Välj kontor"}
            </Typography> 
          }
        </Button>
        )
      }
    }
    else
      return <span/>
  }

  return (
    <section>
    <div className={classes.container}>
      <AppBar position="static" elevation={0} className={classes.root}>
        <Toolbar classes={{gutters: classes.gutters}}>
          <Typography className={classes.title} />
          { menuitems }
        </Toolbar>
      </AppBar>
    </div>
    <LogoType/>
    <div className={classes.wrapper}>
      <Typography variant="h4" className={classes.officetext} id="header-officename-text-id">
        { officename }
      </Typography>
    </div>
    <div className={classes.wrapper}>
    { OfficeSelection() }
    </div>
    {
      (config && config.custombackgroundlink !== '') ? <span/> : <Divider variant="middle" className={classes.divider} id="header-divider-id"/>
    }
    </section>
  )
}

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flex: '1 1 auto'
  },
  root: theme => ({
    flexGrow: 1,
    backgroundColor: theme.palette.background.main
  }),
  gutters: {
    minHeight: 'auto'
  },
  title: {
    flexGrow: 1
  },
  wrapper: {
    display: 'flex',
    justifyContent: 'center'
  },
  officeinfo: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 0
  },
  officetext: theme => ({
    margin: 0, 
    padding: '0.5rem 0 0 0',
    color: theme.palette.button_text.main
  }),
  officebutton: theme => ({
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.button_text.main,
    borderRadius: 0,
    [theme.breakpoints.up('lg')]: {
      '&:hover': {
        backgroundColor: 'black',
        color: 'white'
      }
    },
    [theme.breakpoints.down('lg')]: {
      '&:hover': {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.button_text.main
      }
    }
  }),
  divider: {
    marginTop: '0.5rem'
  },
  queuetext: {

  }
});